import User, { UserData } from './user';

/**
 * Servizio per notificare quando l'utente inizia a giocare con il saldo bonus.
 * La notifica scatta quando il saldo reale eguaglia il saldo bonus.
 */
export class BonusNotifierService {
    private static listeners: (() => void)[] = [];
    private static previousState: { balance: number; bonus: number } | null = null;

    /**
     * Aggiunge un listener per ricevere le notifiche.
     * @param callback La funzione da chiamare quando la notifica viene attivata.
     */
    public static addListener(callback: () => void): void {
        this.listeners.push(callback);
    }

    /**
     * Rimuove un listener.
     * @param callback La funzione da rimuovere.
     */
    public static removeListener(callback: () => void): void {
        this.listeners = this.listeners.filter(cb => cb !== callback);
    }

    /**
     * Attiva manualmente la notifica se le condizioni sono soddisfatte.
     * Controlla se il saldo attuale è uguale al saldo bonus.
     */
    public static notifyIfIsPlayingBonus(): void {
        const userData = User.data;
        if (userData && userData.account.balance === userData.account.bonus) {
            this.notifyListeners();
        }
    }

    /**
     * Aggiorna lo stato del bilancio e controlla se la notifica deve essere attivata.
     * Questo metodo viene chiamato internamente quando i dati dell'utente cambiano.
     * @param currentUserData I dati utente più recenti.
     */
    public static updateAndCheck(currentUserData: UserData): void {
        const currentState = {
            balance: currentUserData.account.balance,
            bonus: currentUserData.account.bonus,
        };

        // Se c'è uno stato precedente, controlla la transizione
        if (this.previousState) {
            const wasDifferent = this.previousState.balance !== this.previousState.bonus;
            const isNowEqual = currentState.balance === currentState.bonus;

            if (wasDifferent && isNowEqual) {
                this.notifyListeners();
            }
        }

        // Aggiorna lo stato precedente
        this.previousState = currentState;
    }

    /**
     * Resetta lo stato del servizio, ad esempio al logout.
     */
    public static reset(): void {
        this.previousState = null;
    }

    private static notifyListeners(): void {
        this.listeners.forEach(callback => {
            try {
                callback();
            } catch (error) {
                console.error("Errore durante l'esecuzione del listener di notifica bonus:", error);
            }
        });
    }
}